import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.mjs'

/** Created by © Tiege Hanley 2023 All Rights Reserved */
class ProductCarousel extends HTMLElement {
  selectors = {
    componentWrapper: '.carousel-wrapper',
    tabs: '.products-list.carousel-tabs',
    tabsContent: '.tabs-content',
    tabContent: '.affinity-tab-content',
    productSwipper: '.products-swiper',
    tab: '.tab-carousel',
    modal: '#products-modal',
    modalContent: '#products-modal .modal-content',
    purchaseOptionSection: '.purchase-options',
    addProductBtn: 'affinity-product-carousel #add-product',
    addressSelectionModal: '.address-product-selection-modal',
    productVariants: '.product-variants',
    learnMoreModal: '#product-learn-more-modal',
    promotionBanner: '.promotion-banner'
  };

  max = { qty: 50, frequency: 90 }
  min = { qty: 1, frequency: 14 }
  defaults = { qty: 1, frequency: 30};
  frequencies = {
    7467975147699: 90,
    8351031918771: 90,
    7832032673971: 90,
    8008852766899: 90
  }
  
  // dev
  transformations = [
    {
      swapProductId: 41672887337057,
      includes: ['TH-SUB-LEVEL-1', 'TH-EYES'],
      message: "We have modified your selection (Skin Care System Level 1 + Eyes) for a better pricing"
    },
    {
      swapProductId: 41672888582241,
      includes: ['TH-SUB-LEVEL-2', 'TH-SERUM'],
      message: "We have modified your selection (Skin Care System Level 2 + Serum) for a better pricing"
    },
    {
      swapProductId: 12463548563553,
      includes: ['TH-SUB-ACNE-L1', 'TH-ACNE'],
      message: "We have modified your selection (Acne System Level 1 + Acne) for a better pricing"
    }
  ]

  // prod
  /*
  transformations = [
    {
      swapProductId: 33449478913,
      includes: ['TH-SUB-LEVEL-1', 'TH-EYES'],
      message: "We have modified your selection (Skin Care System Level 1 + Eyes) for a better pricing"
    },
    {
      swapProductId: 33449478977,
      includes: ['TH-SUB-LEVEL-2', 'TH-SERUM'],
      message: "We have modified your selection (Skin Care System Level 2 + Serum) for a better pricing"
    },
    {
      swapProductId: 7201260077102,
      includes: ['TH-SUB-ACNE-L1', 'TH-ACNE'],
      message: "We have modified your selection (Acne System Level 1 + Acne) for a better pricing"
    }
  ]*/

  collections = [];
  activeTab = null;
  selection = null;
  systemProducts = [];
  otpFirst = true;
  promotionMessage = null;

  constructor () {
    super()
    this.init()
  }

  /********************************** Initialization methods ***************************************/
  async init () {
    await this.getAddresses()
    if (this.customerAddresses && this.customerAddresses.length > 0) {
      this.collections =
        window.TIEGE.affinity && window.TIEGE.affinity.collections
          ? window.TIEGE.affinity.collections
          : []
  
      if (this.promotionMessage != null) {
          $(this.selectors.promotionBanner).text(this.promotionMessage);
          $(this.selectors.promotionBanner).show();
      } else {
          $(this.selectors.promotionBanner).hide();
      }
  
      const systemCollection = this.collections ? this.collections.find(c => c.id === 'systems') : []
      if (systemCollection && systemCollection.products.length > 0) {
        systemCollection.products.forEach(p =>  this.systemProducts.push(...p.variants.map(v => v.id)))
      }
  
      // Waiting for DOM
      const timer = setInterval(() => {
        if (document.querySelector(this.selectors.componentWrapper)) {
          clearInterval(timer)
          this.initTabsContent()
          $('#recharge-customer-portal').append('<div class="affinity-alerts" id="affinity-alerts"></div>');
        }
      }, 1000)
      $(this.selectors.addProductBtn).on("click", () => { this.addProduct();});
      document.getElementById('closeProductBtn').addEventListener('click', () => {
        $(this.selectors.modal).hide()
      })
  
      document.getElementById('productSelectAddressBtn').addEventListener('click', () => {
        this.openAddressSelectionModal()
      })
  
      document.getElementById('close-learn').addEventListener('click', () => {
        $(this.selectors.learnMoreModal).hide();
      })
  
      window.closeAddressSelectionModal = (event) => {
        this.closeAddressSelectionModal(event)
      }
      $('affinity-product-carousel').show();
    } else {
      $('affinity-product-carousel').hide();
    }
  }

  /** Creates the tabs and tabs contents and initialize the swippers */
  async initTabsContent () {
    if (this.collections.length > 0) {
      this.activeTab = this.collections[0].id
      let tabs = []
      for (var i = 0; i < this.collections.length; ++i) {
        if (this.collections[i].products && this.collections[i].products.length > 0) {
          tabs.push(`<li class="tab-carousel" data-tab-target="${this.collections[i].id}"><span>${this.collections[i].name}</span></li>`)
          this.createTabsContent(this.collections[i].id, this.collections[i].name, this.collections[i].products)
        }
      }
      $(this.selectors.tabs).append(tabs.join('\n'))

      /** Add click listener to the tabs */
      this.activateTab(this.collections[0].id)
      $(`.tab-carousel[data-tab-target='${this.activeTab}']`).addClass('active')
      $(this.selectors.tabs).on("click","li", (event) => { this.changeTabsContent(event)});
      $(`.swiper.products-swiper .swiper-wrapper`).on("click", "button.add", (event) => { this.showProduct(event);})
      $(`.swiper.products-swiper .swiper-wrapper`).on("click", "button.learn", (event) => { this.showLearnMore(event);})
    }
    $('affinity-product-carousel .loading-affinity').hide();
    $('.products').show();
  }

  /** Create the swipper for an specific collection */
  createTabsContent (collectionId, collectionName, products) {
    let sliders = []

    for (let i = 0; i < products.length; i++) {
      if (!products[i].tags.includes('hidden')) {
        sliders.push(this.createSlider(collectionId, products[i].featured_image, products[i], null))
      }
    }

    let swiper = `<div class="swiper products-swiper" id="c${collectionId}">` +
      '<div class="swiper-wrapper">'+sliders.join("\n")+`</div><div class="swiper-pagination ${collectionId}"></div></div>`+
      `<div class="swiper-button-next outside c${collectionId}"></div><div class="swiper-button-prev outside c${collectionId}"></div>`;

    let tabContent = `<div class="affinity-tab-content" data-tab-content="${collectionId}"><span class="tab-title">${collectionName}</span><div class="outer-swiper-wrapper">${swiper}</div></div>`
    $(this.selectors.tabsContent).append(tabContent)
    this.initCarousel(`#c${collectionId}`, collectionId)
    $(`${this.selectors.tabContent}[data-tab-content='${collectionId}']`).hide()
  }

  createSlider(collectionId, image, product, variant) {
    const productSection = variant ? `<div class="product-name"><span>${product.title}</span>` : `<span class="product-name">${product.title}</span>`
    return '<div class="swiper-slide">' +
                '<div class="flex-column align-items--center h-full justify-content--space-between w1">' +
                    '<div>'+
                      '<div class="affinity-image-wrapper">'+
                        `<div class="hover-wrapper"><button class="learn" data-collection-id="${collectionId}" data-product-id="${product.id}" data-variant-id="${variant ? variant.id : null}">Learn more</button></div>`+
                        `<img src="${image}" loading="lazy">`+
                      '</div>' + 
                      productSection+
                    '</div>' +
                    `<div class="w1 flex-column align-items--center"><span class="product-price">${this.getPriceToDisplay(product, variant)}</span><button class="btn-primary w1 add" data-collection-id="${collectionId}" data-product-id="${product.id}" data-variant-id="${variant ? variant.id : null}"><svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M8 15.429A7.429 7.429 0 1 0 8 .57 7.429 7.429 0 0 0 8 15.43ZM8 4.571v6.858M4.571 8h6.858" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path></svg> Add</button>` +
                    `<button class="btn-secondary w1 learn" data-collection-id="${collectionId}" data-product-id="${product.id}" data-variant-id="${variant ? variant.id : null}">Learn More</button></div>` +
                '</div>' +
              '</div>';
  }

  getPriceToDisplay (product, variant) {
    let displayVariant = variant
    if (!variant) {
      if (product.display_higher_price === "true") {
        displayVariant = product.variants.reduce((previous, current) => {
          return Number(current.price) > Number(previous.price) ? current : previous;
        });
      } else {
        displayVariant = product.variants.reduce((previous, current) => {
          return Number(current.price) < Number(previous.price) ? current : previous;
        });
      }
    }
    
    if (this.otpFirst) {
      return window.formatPriceStoreCurrency(displayVariant.price)
    }
    return product.selling_plan !== 0 ? window.formatPriceStoreCurrency(displayVariant.selling_plan_data.price) : window.formatPriceStoreCurrency(displayVariant.price)
  }

  /** Initialize a swipper
  * @param  {String} carouselSelector  Selector of the carousel to be initialized
  */
  initCarousel (carouselSelector, id) {
    let swiperProperties = {
      slidesPerView: 2,
      centeredSlides: false,
      spaceBetween: 32,
      breakpoints: {
        500: {
          slidesPerView: 2
        },
        1000 : {
          slidesPerView: 3
        }
      }
    }

    swiperProperties.pagination = {
      el: '.swiper-pagination'
    }

    swiperProperties.navigation = {
      nextEl: `.swiper-button-next.outside.c${id}`,
      prevEl: `.swiper-button-prev.outside.c${id}`
    }

    new Swiper(carouselSelector, swiperProperties)
  }

  /********************************** Tabs behavior methods ***************************************/
  /** Handles the change of tab
  * @param {Object} event  Trigger event of the change tab
  */
  changeTabsContent (event) {
    const target = $(event.target).parent().attr('data-tab-target')
    this.activateTab(target)
    $(event.target).parent().addClass('active')
  }

  /** Activates a tab and its content
  * @param {String}  id   Id of the collection to activate
  */
  activateTab (id) {
    this.activeTab = id
    // Hide all tabs content and display only the selected one
    $(this.selectors.tabContent).hide()
    $(`${this.selectors.tabContent}[data-tab-content='${id}']`).show()

    $(this.selectors.tab).removeClass('active')
  }

  showLearnMore (event) {
    const data = $(event.target).data();
    const productCollection = this.collections.find(c => c.id.toString() === data.collectionId.toString());
     if (productCollection) {
      const product = productCollection.products.find(p => p.id.toString() === data.productId.toString());
      let activateAccordion = false
      if (product) {
        // Clear data
        $(`${this.selectors.learnMoreModal} .collection-name`).text(productCollection.name);
        $(`${this.selectors.learnMoreModal} .title`).text(product.title);
        $(`${this.selectors.learnMoreModal} .variant-title`).remove();
        $(`${this.selectors.learnMoreModal} .affinity-accordion`).remove();

        if (!data.variantId) {
          $(`${this.selectors.learnMoreModal} .description`).html(decodeURIComponent(decodeURI(product.description.replaceAll('%', '%25')).replaceAll('+', ' ')));
          const contents = [];
          const benefits = [];
          const how_to = [];
          if (product.contents.ingredients != "") {
            contents.push('<div class="accordion__item">'+
                  `<button class="accordion-btn flex w1 justify-content--space-between"><span>Ingredients</span><span class="plus_icon"></span></button>`+
                  `<div class="accordion-content">${decodeURIComponent(decodeURI(product.contents.ingredients.replaceAll('%', '%25')).replaceAll('+', ' '))}</div>`+
                '</div>'
            )
          }

          product.contents.benefits.forEach(b => {
            if (b.icon != "" && b.description != "") {
              benefits.push(`<div><img src="${b.icon}" alt="Benefit image" height="40px" width="40px"><p>${b.description}</p></div>`)
            }
          });
          if (benefits.length > 0) {
            contents.push('<div class="accordion__item">'+
                    `<button class="accordion-btn flex w1 justify-content--space-between"><span>Benefits</span><span class="plus_icon"></span></button>`+
                    `<div class="accordion-content"><div class="product-benefits">${benefits.join('\n')}</div></div>`+
                  '</div>'
            )
          }

          for (var i=1; i <= 6; ++i) {
            if (product.contents.how_to[`step_${i}`] != "") {
              how_to.push(`<li>${decodeURIComponent(product.contents.how_to[`step_${i}`]).replaceAll('+', ' ').replaceAll('\n', '<br>')}</li>`)
            }
          }

          if(how_to.length > 0) {
            contents.push('<div class="accordion__item">'+
                    `<button class="accordion-btn flex w1 justify-content--space-between"><span>How to</span><span class="plus_icon"></span></button>`+
                    `<div class="accordion-content"><div><ol>${how_to.join('\n')}</ol></div>`+
                  '</div>'
            )
          }

          if (contents.length > 0) {
            activateAccordion = true;
            $(`<div class="affinity-accordion"><div>${contents.join('\n')}</div></div>`).insertAfter(`${this.selectors.learnMoreModal} .description`)
          }
        } else {
          const variant = product.variants.find(v => v.id.toString() === data.variantId.toString());
            $(`${this.selectors.learnMoreModal} .description`).html(decodeURIComponent(decodeURI(variant.description.replaceAll('%', '%25')).replaceAll('+', ' ')));
            
            $(`${this.selectors.learnMoreModal} .title`).append(`<span class="variant-title">${variant.title}</span>`);
            const contents = []
            if (variant.contents && variant.contents.length > 0) {
              variant.contents.forEach(c => {
                  if (c.content instanceof Object && c.content.benefits instanceof Array){
                    const benefits = []
                    c.content.benefits.forEach(b => {
                      benefits.push(`<div><img src="${b.image}"><span>${b.name}</span></div>`);
                    })
                    contents.push('<div class="accordion__item">'+
                        `<button class="accordion-btn flex w1 justify-content--space-between"><span>${c.title}</span><span class="plus_icon"></span></button>`+
                        `<div class="accordion-content"><div class="benefits">${benefits.join('\n')}</div></div>`+
                      '</div>'
                    )
                  } else {
                    contents.push('<div class="accordion__item">'+
                        `<button class="accordion-btn flex w1 justify-content--space-between"><span>${c.title}</span><span class="plus_icon"></span></button>`+
                        `<div class="accordion-content">${decodeURIComponent(decodeURI(c.content))}</div>`+
                      '</div>'
                    )
                  }
              })
              $(`<div class="affinity-accordion"><div>${contents.join('\n')}</div></div>`).insertAfter(`${this.selectors.learnMoreModal} .description`)
              activateAccordion = true;
            }
        }
        if (activateAccordion) {
            $(`${this.selectors.learnMoreModal} .accordion-content`).hide();
            $(`${this.selectors.learnMoreModal} .accordion-btn`).on('click', (e) => {
              const parent = $(e.target).parents('.accordion__item')
              const currentActive = $(parent).find('.plus_icon.is-active')
              $(`${this.selectors.learnMoreModal} .accordion-content`).hide();
              $(`${this.selectors.learnMoreModal} .plus_icon`).removeClass('is-active');
              if (currentActive && currentActive.length <= 0) {
                $(`${this.selectors.learnMoreModal} .accordion-content`).hide();
                $(parent).find('.plus_icon').addClass('is-active');
                $(parent).children('.accordion-content').show();
              }
            })
        }
        $(`${this.selectors.learnMoreModal} .primary-btn.add`).data({})
        $(`${this.selectors.learnMoreModal} .primary-btn.add`).data(data);
        $(`${this.selectors.learnMoreModal} .primary-btn.add`).on('click', (event) => {this.showProduct(event)});
        $(this.selectors.learnMoreModal).show();
      }
    }
  }

  showProduct (event) {
     const data = $(event.target).data();
     const productCollection = this.collections.find(c => c.id.toString() === data.collectionId.toString());
     if (productCollection) {
      const product = productCollection.products.find(p => p.id.toString() === data.productId.toString());
      if (product) {
        this.selection = {};
        this.selection.product = product;
        this.selection.qty = this.defaults.qty;
        this.selection.frequency = this.frequencies[Number(data.productId)] ? this.frequencies[Number(data.productId)] : this.defaults.frequency;
        $(this.selectors.purchaseOptionSection).empty();
        if (data.variantId) {
          this.openVariantModal(product, data.variantId);
        } else {
          this.openProductModal(product);
        }
      }
    }
  }
  
  async openVariantModal (product, variantId) {
    const variant = product.variants.find(v => v.id.toString() === variantId.toString());
    this.selection.variant = variant;
    $(this.selectors.modalContent).find('.product-img').attr('src', variant.featured_image ? variant.featured_image : product.featured_image);
    $(this.selectors.modalContent).find('.product-title').text(`${product.title}`);
    $(this.selectors.modalContent).find('#product-address').text(formatSimpleAddress(this.customerAddresses[0]));
    this.addPurchaseOptions(product);
    $(this.selectors.productVariants).hide();
    $(this.selectors.modal).show();
  }

  async openProductModal (product) {
    $(this.selectors.modalContent).find('.product-img').attr('src', product.featured_image);
    $(this.selectors.modalContent).find('.product-title').text(product.title);
    $(this.selectors.modalContent).find('#product-address').text(formatSimpleAddress(this.customerAddresses[0]));
    $(this.selectors.modalContent).find('.product-total').text(window.formatPriceStoreCurrency(0));

    const variants = []
    $(`${this.selectors.productVariants} select`).empty();
    this.selection.variant = product.variants.find(v => v.inventory_policy === "continue" || (v.inventory_policy === "deny" && v.inventory_qty > 0))
    product.variants.forEach(v => {
      if ((v.inventory_policy === "continue" || (v.inventory_policy == "deny" && v.inventory_qty > 0)) && v.title !== 'Default Title') {
        variants.push(`<option value=${v.id}>${v.title}</option>`)
      }
    })
    
    $(`${this.selectors.productVariants} select`).append(variants.join('\n'));
    $(`${this.selectors.productVariants} select`).on('change', (e) => {
      this.changeSelectedVariant(e.target.value)
    });
    
    this.addPurchaseOptions(product);
    if (variants.length > 0) {
      $(this.selectors.productVariants).show();
    } else {
      $(this.selectors.productVariants).hide();
    }
    $(this.selectors.modal).show();
  }

  changeSelectedVariant (id) {
      this.selection.variant = this.selection.product.variants.find(v => v.id === id)
      this.updatePrices()
  }
  
  createQtySelector() {
    return '<div class="qty-selector">'+
        '<div><svg data-action="decrement" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M8 15.429A7.429 7.429 0 1 0 8 .57 7.429 7.429 0 0 0 8 15.43ZM4.571 8h6.858" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>'+
        `<span>${this.defaults.qty}</span>`+
        '<div><svg data-action="increment" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M8 15.429A7.429 7.429 0 1 0 8 .57 7.429 7.429 0 0 0 8 15.43ZM8 4.571v6.858M4.571 8h6.858" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>'+
      '</div>'
  }

  createFrequencySelector(productId) {
    return '<div class="frequency-selector">'+
        '<div><svg data-action="decrement" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M8 15.429A7.429 7.429 0 1 0 8 .57 7.429 7.429 0 0 0 8 15.43ZM4.571 8h6.858" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>'+
        `<span>${this.frequencies[Number(productId)] ? this.frequencies[Number(productId)] : this.defaults.frequency}</span>`+
        '<div><svg data-action="increment" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M8 15.429A7.429 7.429 0 1 0 8 .57 7.429 7.429 0 0 0 8 15.43ZM8 4.571v6.858M4.571 8h6.858" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>'+
      '</div>'
  }

  // Add purchase options and pre-select option
  addPurchaseOptions (product) {
    // Select subscription as default
    //this.selection.purchaseOption = product.requires_selling_plan || (!product.requires_selling_plan && product.selling_plan && product.selling_plan !==0) ? 'subscription' : 'one-time'

    // Select OTP as default
    this.selection.purchaseOption = 'one-time'
    if (product.requires_selling_plan) {
      $(this.selectors.purchaseOptionSection).append(`<div class="flex align-items--center">You get ${this.createQtySelector()} of these, every</div>`);
    } else {
      if (product.selling_plan && product.selling_plan !== 0) {
        $(this.selectors.purchaseOptionSection).append(
          `<div class="flex">Send me ${this.createQtySelector()} of these, every</div>`+
          `<div class="option"><div class="flex align-items--center"><input type="radio" name="purchaseOption" data-option="one-time" ${this.otpFirst ? 'checked' : ''}/><span>One time only</span></div></div>`+
          '<div class="option flex-column">'+
            `<div class="flex align-items--center"><input type="radio" name="purchaseOption" data-option="subscription" ${this.otpFirst ? '' : 'checked'}/><span>As a subscription</span></div>`+
            `<div class="flex align-items--center frequency-wrapper">every ${this.createFrequencySelector(product.id)} days</div>`+
          '</div>');
        $("affinity-product-carousel input[type='radio'][name='purchaseOption']").on("change", (e) => { this.changePurchaseOption(e); });
      } else {
        $(this.selectors.purchaseOptionSection).append(`<div class="flex align-items--center">Send me ${this.createQtySelector()} of these, only once</div>`)
      }
    }

    // Add event listener
    $('.qty-selector svg').on("click", (event) => {
      const data = $(event.target).data() && $(event.target).data().action ? $(event.target).data() : $(event.target).parent().data();
      this.changeQty(data.action);
    })
    $('.frequency-selector svg').on("click", (event) => {
      const data = $(event.target).data() && $(event.target).data().action ? $(event.target).data() : $(event.target).parent().data();
      this.changeFrequency(data.action);
    })
    this.updatePrices();
  }


  /********************************** Address modal methods ***************************************/
  async getAddresses () {
    if (!this.customerAddresses || this.customerAddresses.length <= 0) {
      const session = await recharge.auth.loginCustomerPortal();
      const addressesResponse = await recharge.address.listAddresses(session, {
        limit: 25,
        sort_by: 'id-asc',
        include: ['subscriptions']
      })

      this.customerAddresses = addressesResponse.addresses.filter(a => {
        const subscriptions = a.include.subscriptions.find(s => s.next_charge_scheduled_at != null);
        if (subscriptions != null && subscriptions != undefined) {
          a.include.subscriptions = subscriptions instanceof Array ? subscriptions : [subscriptions]
        } else {
          a.include.subscriptions = []
        }
        return a.include.subscriptions.length > 0
      }).sort((a,b) => {
        const minSubscriptionA = a.include.subscriptions ? new Date(Math.min(...a.include.subscriptions.map(element => { return new Date(element.next_charge_scheduled_at) }))) : 0
        const minSubscriptionB = b.include.subscriptions ? new Date(Math.min(...b.include.subscriptions.map(element => { return new Date(element.next_charge_scheduled_at) }))) : 0
        return Number(minSubscriptionA) - Number(minSubscriptionB)
      })
    }
  }

  /********************************** Product modal behavior methods ***************************************/
  async addProduct () {
      if (this.selection) {
        $(this.selectors.addProductBtn).attr('disabled', true)
        $(`${this.selectors.addProductBtn} span`).hide()
        $(`${this.selectors.addProductBtn} #spinner-add-product`).show()
        const session = await recharge.auth.loginCustomerPortal()
        let response = null;
        const addressId = this.selectedAddress ? this.selectedAddress : (this.customerAddresses.length > 0 ? this.customerAddresses[0].id : null)

        if (addressId == null) {
           this.displayNotification('error', `We could't add this product to your order due to an internal error`)
          $(this.selectors.addProductBtn).attr('disabled', false);
          $(`${this.selectors.addProductBtn} span`).show();
          $(`${this.selectors.addProductBtn} #spinner-add-product`).hide();
          this.selectedAddress = null;
          this.selection = {};
          $(this.selectors.modal).hide()
          $('#products-modal').hide();
        } else {
          try {
            let processAdd = true;
            // If the customer is adding a system, check no system exist in the adddress
            if (this.systemProducts.includes(this.selection.variant.id.toString())) {
              processAdd = await this.validateAddSystem(addressId, session);
            } else {
              // Check if a subscription for a system needs to be upgraded
              if (this.selection.purchaseOption === 'subscription') {
                processAdd = await this.processIndividualTransformation(addressId, session);
              }
            }
    
            if (processAdd) {
              if (this.selection.purchaseOption === 'subscription') {
                // Get next charge scheduled at
                const chargeResponse = await recharge.charge.listCharges(session, {
                  limit: 25,
                  sort_by: 'scheduled_at-asc',
                  address_id: addressId,
                  status: ['queued']
                });
    
                if (chargeResponse && chargeResponse.charges.length > 0) {
                  response = await recharge.subscription.createSubscription(session, {
                    address_id: addressId,
                    quantity: this.selection.qty,
                    external_variant_id: {
                      ecommerce: this.selection.variant.id.toString()
                    },
                    product_title: this.selection.product.title,
                    next_charge_scheduled_at: chargeResponse.charges[0].scheduled_at,
                    charge_interval_frequency: this.selection.frequency,
                    order_interval_frequency: this.selection.frequency,
                    order_interval_unit: 'day'
                  }, {commit: true});
                  this.displayNotification('success', `We've added this product to your order.`);
                  window.refresh()
                } else {
                  this.displayNotification('error', 'Unable to add the product because there is no scheduled order')
                }
              } else {
                response = await recharge.onetime.createOnetime(session, {
                  address_id: addressId,
                  quantity: this.selection.qty,
                  external_variant_id: {
                    ecommerce: this.selection.variant.id.toString()
                  },
                  product_title: this.selection.product.title,
                  add_to_next_charge: true
                }, {commit: true});
                this.displayNotification('success', `We've added this product to your next shipment! Discounts will be automatically applied`);
                window.refresh()
              }
            }
          } catch (ex) {
            this.displayNotification('error', `We could't add this product to your order because ${Object.values(JSON.parse(ex.message.toLowerCase())).join(',')}`)
          } finally {
            $(this.selectors.addProductBtn).attr('disabled', false);
            $(`${this.selectors.addProductBtn} span`).show();
            $(`${this.selectors.addProductBtn} #spinner-add-product`).hide();
            this.selectedAddress = null;
            this.selection = {};
            $(this.selectors.modal).hide()
            $('#products-modal').hide();
          }
        }
      }
    }

  // Validates if the customer already has a system in their address
  async validateAddSystem (addressId, session) {
    const payload = {
      limit: 25,
      sort_by: 'id-asc',
      address_id: addressId
    };

    const existingOneTimes = await recharge.onetime.listOnetimes(session, payload);
    const existingSubscriptions = await recharge.subscription.listSubscriptions(session, payload);
    const existingOneTimeSystem = existingOneTimes && existingOneTimes.onetimes && existingOneTimes.onetimes.length > 0 ? existingOneTimes.onetimes.filter(o => this.systemProducts.includes(o.external_variant_id.ecommerce)) : null
    const existingSubscriptionSystem = existingSubscriptions && existingSubscriptions.subscriptions && existingSubscriptions.subscriptions.length > 0 ? existingSubscriptions.subscriptions.filter(s => this.systemProducts.includes(s.external_variant_id.ecommerce)) : null

    if ((existingOneTimeSystem && existingOneTimeSystem.length > 0) || (existingSubscriptionSystem && existingSubscriptionSystem.length > 0)) {
      this.displayNotification('error', 'You already have a system in your order, click manage subscription to change the system')
      return false
    } else {
      return await this.processSystemTransformation(addressId, session)
    }
  }

  async processIndividualTransformation (addressId, session) {
    let continueProcessing = true
    const existingSubscriptions = await recharge.subscription.listSubscriptions(session, {
      limit: 25,
      sort_by: 'id-asc',
      address_id: addressId,
      status: 'active'
    });

    const existingSubscriptionSystem = existingSubscriptions && existingSubscriptions.subscriptions && existingSubscriptions.subscriptions.length > 0 ? existingSubscriptions.subscriptions.filter(s => this.systemProducts.includes(s.external_variant_id.ecommerce)) : null;
    if (existingSubscriptionSystem && existingSubscriptionSystem.length > 0) {
      const products = [existingSubscriptionSystem[0].sku, this.selection.variant.sku];
      let transformation = null;

      // Check if some transformation needs to be applied based on the existing system and the new individual product
      this.transformations.forEach(t => {
        if (t.includes.every(r => products.includes(r))) {
          transformation = t
        }
      })
      continueProcessing = await this.processTransformation(session, transformation, existingSubscriptionSystem[0])
      // If the trasformation was applied but the customer was trying to add the individual product with a qty greater than 1, then continue adding the remaining qty
      if (!continueProcessing && this.selection.qty > 1) {
        this.selection.qty = this.selection.qty - 1;
        continueProcessing = true
      }
    }
    return continueProcessing
  }

  async processSystemTransformation (addressId, session) {
    let continueProcessing = true
    const existingSubscriptions = await recharge.subscription.listSubscriptions(session, {
      limit: 25,
      sort_by: 'id-asc',
      address_id: addressId,
      status: 'active'
    });

    if (existingSubscriptions && existingSubscriptions.subscriptions && existingSubscriptions.subscriptions.length > 0) {
      const skus = existingSubscriptions.subscriptions.map(item => item.sku);
      const products = [...skus, this.selection.variant.sku]
      let transformation = null;
  
      this.transformations.forEach(t => {
        if (t.includes.every(r => products.includes(r))) {
          transformation = t
        }
      })
  
      if (transformation !== null) {
        const existingSubscription = existingSubscriptions.subscriptions.find(s => transformation['includes'].includes(s.sku) && !s.sku.startsWith('TH-SUB'))
        continueProcessing = await this.processTransformation(session, transformation, existingSubscription)
      }
    }
    return continueProcessing
  }

  async processTransformation (session, transformation, subscription) {
    let continueProcessing = true

    if (transformation !== null) {
      const productResponse = await recharge.product.productSearch(session, {
        limit: 1,
        format_version: '2022-06',
        external_variant_ids: [transformation.swapProductId.toString()]
      });

      if (productResponse && productResponse.products && productResponse.products.length > 0) {
        const plan = productResponse.products[0].plans.find(p => p.external_variant_ids.includes(transformation.swapProductId.toString()));
        const response = await recharge.subscription.updateSubscription(session, subscription.id, {
          external_variant_id: {
            ecommerce: transformation.swapProductId.toString()
          },
          plan_id: plan.id,
          order_interval_unit: subscription.order_interval_unit,
          charge_interval_frequency: subscription.charge_interval_frequency,
          order_interval_frequency: subscription.order_interval_frequency
        }, {commit: true});
        continueProcessing = false
        this.displayNotification('info', transformation.message);
        window.refresh();
      }
    }
    return continueProcessing
  }

  changeQty (action) {
     if (action === 'increment') {
       this.selection.qty += this.selection.qty < this.max.qty ? 1 : 0;
     } else {
       this.selection.qty -= this.selection.qty > this.min.qty ? 1 : 0;
     }
     $('.qty-selector span').text(this.selection.qty);
     this.updatePrices();
  }

  changeFrequency (action) {
     if (action === 'increment') {
       console.log(this.max.frequency);
       if (this.selection.frequency < this.max.frequency) {
         this.selection.frequency += 1;
       }
     } else {
       if(this.selection.frequency > this.min.frequency) {
         this.selection.frequency -= 1;
       }
     }
    $('.frequency-selector span').text(this.selection.frequency);
  }

  changePurchaseOption (event) {
    const data = $(event.target).data();
    if (data) {
      this.selection.purchaseOption = data.option
      if (this.selection.purchaseOption === 'subscription') {
         if (!this.selection.product.requires_selling_plan) {
           $(this.selectors.modalContent).find('.discount-product-total').show();
           $(this.selectors.modalContent).find('.product-total').addClass('line-through');
           $('affinity-product-carousel .frequency-wrapper').show();
         }
      } else {
        $(this.selectors.modalContent).find('.discount-product-total').hide();
        $(this.selectors.modalContent).find('.product-total').removeClass('line-through');
        $('affinity-product-carousel .frequency-wrapper').hide();
      }
    }
  }
  
  /** Address selection methods */
  selectAddress () {
    this.selectedAddress = document.querySelector(
      'input[name="product-address"]:checked'
    ).value
    const address = this.customerAddresses.find(
      address => address.id.toString() === this.selectedAddress
    )
    $(this.selectors.addressSelectionModal).remove()
    $('#product-address').html(window.formatSimpleAddress(address))
  }

  openAddressSelectionModal () {
    let addressSelection = ''
    if (!this.selectedAddress) {
      this.selectedAddress = this.customerAddresses[0].id
    }
    this.customerAddresses.forEach(address => {
      addressSelection += '<div class="aff-address-wrapper flex-row justify-content--space-between">' +
        '<div class="flex-row align-items--center">'

      if (address.id.toString() === this.selectedAddress.toString()) {
        addressSelection += `<input type="radio" name="product-address" value="${address.id}" checked/>`
      } else {
        addressSelection += `<input type="radio" name="product-address" value="${address.id}"/>`
      }
      addressSelection += `<span>${formatSimpleAddress(address)}</span>` +
        '</div>' +
          '<div class="flex-row align-items--center">' +
            `<div class="aff-currency">${window.BARREL.currencies.get(address.presentment_currency)}</div>` +
              `<span class="tiege-subtitle">Pay in ${address.presentment_currency}</span>` +
            '</div>' +
          '</div>'
    })

    const modal = '<div class="modal-affinity address-product-selection-modal onclick="closeAddressSelectionModal(event)">' +
      '<div class="modal-content flex-column">' +
        '<span class="tiege-title">Select an address</span>' +
        addressSelection +
        '<button class="primary-btn">Save</button>' +
      '<div>' +
    '</div>'
    $('.recharge-container').append(modal)
    $(`${this.selectors.addressSelectionModal} button`).on('click', () => {
      this.selectAddress();
    })
  }

  closeAddressSelectionModal () {
    if ($(event.target).is(this.selectors.addressSelectionModal)) {
      $(this.selectors.addressSelectionModal).remove()
    }
  }

  /********************************** Helpers ***************************************/
  updatePrices () {
    $(this.selectors.modalContent).find('.product-total').text(window.formatPriceStoreCurrency(Number(this.selection.variant.price) * this.selection.qty));
    if(this.selection.purchaseOption === 'subscription' && !this.selection.product.requires_selling_plan) {
      $(this.selectors.modalContent).find('.discount-product-total').show();
      $(this.selectors.modalContent).find('.product-total').addClass('line-through');
      $(this.selectors.modalContent).find('.discount-product-total').text(window.formatPriceStoreCurrency(Number(this.selection.variant.selling_plan_data.price) * this.selection.qty));
    }
    if (this.selection.purchaseOption === 'one-time') {
      if (this.selection.variant.selling_plan_data) {
        $(this.selectors.modalContent).find('.discount-product-total').text(window.formatPriceStoreCurrency(Number(this.selection.variant.selling_plan_data.price) * this.selection.qty));
      }
      $(this.selectors.modalContent).find('.discount-product-total').hide();
      $(this.selectors.modalContent).find('.product-total').removeClass('line-through');
    }
  }

  displayNotification (type, message) {
    const styleClass = `affinity-${type}`;
    const id =`${type}-${uuidv4()}`;
    if ($('.affinity-alerts').length < 0) {
      $('#recharge-customer-portal').append('<div class="affinity-alerts" id="affinity-alerts"></div>');
    }

    $('.affinity-alerts').append(`<div class="${styleClass}" id="${id}">`+
          '<div class="flex align-items--baseline">'+(type === 'error' ? 
                   '<svg xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M9.017 1.2a1.143 1.143 0 0 0-2.034 0L.697 13.771a1.143 1.143 0 0 0 1.017 1.658h12.572a1.143 1.143 0 0 0 1.017-1.658L9.017 1.2Z" stroke="#FFFFFF" stroke-width="1.143px" stroke-linecap="round" stroke-linejoin="round" fill="none"></path><circle cx="8" cy="12" transform="rotate(-180 8 12)" fill="#FFFFFF" r="1"></circle><path d="M8 9V5.5" stroke="#FFFFFF" stroke-width="1.2px" stroke-linecap="round" stroke-linejoin="round" fill="none"></path></svg>' :
                   (type === 'success' ? '<svg xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="13"><path d="M14.5 1 4.967 12 1.5 8.333" stroke="#FFFFFF" stroke-width="1.2px" stroke-linecap="round" stroke-linejoin="round" fill="none"></path></svg>' : '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18px" height="16px"><path fill="white" d="M504.1,256C504.1,119,393,7.9,256,7.9C119,7.9,7.9,119,7.9,256C7.9,393,119,504.1,256,504.1C393,504.1,504.1,393,504.1,256z"/><path fill="#58a4b0" d="M323.2 367.5c-1.4-2-4-2.8-6.3-1.7-24.6 11.6-52.5 23.9-58 25-.1-.1-.4-.3-.6-.7-.7-1-1.1-2.3-1.1-4 0-13.9 10.5-56.2 31.2-125.7 17.5-58.4 19.5-70.5 19.5-74.5 0-6.2-2.4-11.4-6.9-15.1-4.3-3.5-10.2-5.3-17.7-5.3-12.5 0-26.9 4.7-44.1 14.5-16.7 9.4-35.4 25.4-55.4 47.5-1.6 1.7-1.7 4.3-.4 6.2 1.3 1.9 3.8 2.6 6 1.8 7-2.9 42.4-17.4 47.6-20.6 4.2-2.6 7.9-4 10.9-4 .1 0 .2 0 .3 0 0 .2.1.5.1.9 0 3-.6 6.7-1.9 10.7-30.1 97.6-44.8 157.5-44.8 183 0 9 2.5 16.2 7.4 21.5 5 5.4 11.8 8.1 20.1 8.1 8.9 0 19.7-3.7 33.1-11.4 12.9-7.4 32.7-23.7 60.4-49.7C324.3 372.2 324.6 369.5 323.2 367.5zM322.2 84.6c-4.9-5-11.2-7.6-18.7-7.6-9.3 0-17.5 3.7-24.2 11-6.6 7.2-9.9 15.9-9.9 26.1 0 8 2.5 14.7 7.3 19.8 4.9 5.2 11.1 7.8 18.5 7.8 9 0 17-3.9 24-11.6 6.9-7.6 10.4-16.4 10.4-26.4C329.6 96 327.1 89.6 322.2 84.6z"/></svg>')) +
          `<span>${message}</span></div>`+
          '<button class="h1 align-self--baseline"><svg xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="m10.423 5.577-4.846 4.846M5.577 5.577l4.846 4.846M8 15.429A7.429 7.429 0 1 0 8 .57 7.429 7.429 0 0 0 8 15.43Z" stroke="#FFFFFF" stroke-width="1.2px" stroke-linecap="round" stroke-linejoin="round" fill="none"></path></svg></button>'+
        '</div>')
    $(`#${id} button`).on('click', ()  => {
        $(`#${id}`).remove()
    });

    if (type !== 'info') {
      setTimeout(function() {
        if ($(`#${id}`)) {
            $(`#${id}`).fadeOut(1000, () => {$(`#${id}`).remove()})
        }
      }, 10000)
    }
  }
}

customElements.define('affinity-product-carousel', ProductCarousel)
